// React
import React, { Component } from "react";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Components
import Earnings from "./financialDashboard/Earnings";
import SalesTab from "./financialDashboard/SalesTab";
import TopProducts from "./financialDashboard/TopProducts";
import { default as Loadable } from "../../components/_Shared/commonLoadable";
import { DateRangePicker } from "react-dates";

// Module
import {
  getSalesAnalysis,
  updateDate
} from "../module/analytics/salesAnalysis";
import { getTopProducts } from "../module/analytics/topSellingProducts";

import "./FinancialDashboard.css";

import moment from "moment";

class FinancialDashboard extends Component {
  state = {
    focusedInput: null
  };

  componentDidMount() {
    this.props.getSalesAnalysis(
      moment(new Date()).add(-7, "days"),
      moment(new Date())
    );
    this.props.getTopProducts();
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  /**
   * We are using this function to change the orientation props in our
   * <DateRangePicker /> component
   */
  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  onFocusChange = focusedInput => {
    this.setState({ focusedInput });
  };

  onDatesChange = ({ startDate, endDate }) => {
    this.props.updateDate(startDate, endDate);
  };

  render() {
    const {
      isFetching,
      earnings,
      orders,
      breakdown,
      orderStatus
    } = this.props.salesAnalysis;

    const { suppliers } = this.props.topSellingProducts;

    const { focusedInput, width } = this.state;

    return (
      <Loadable active={isFetching}>
        <div className="financial-dashboard__header">
          <DateRangePicker
            startDateId="datepicker_start"
            endDateId="datepicker_end"
            startDate={this.props.salesAnalysis.startDate}
            endDate={this.props.salesAnalysis.endDate}
            focusedInput={focusedInput}
            onFocusChange={this.onFocusChange}
            onDatesChange={this.onDatesChange}
            showDefaultInputIcon
            isOutsideRange={date =>
              date.isBefore("2017-01-01") || date.isAfter(moment().format())
            }
            isDayHighlighted={() => false}
            onClose={({ startDate, endDate }) =>
              this.props.getSalesAnalysis(startDate, endDate, orderStatus)
            }
            orientation={width <= 991 ? "vertical" : "horizontal"}
            withFullScreenPortal={width <= 991 ? true : false}
          />
        </div>
        {earnings && <Earnings earnings={earnings} />}
        {orders && <SalesTab orders={orders} breakdown={breakdown} />}
        {suppliers && <TopProducts suppliers={suppliers} />}
      </Loadable>
    );
  }
}

function mapStateToProps(state) {
  return {
    salesAnalysis: state.analytics.salesAnalysis,
    topSellingProducts: state.analytics.topSellingProducts
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { getSalesAnalysis, getTopProducts, updateDate },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinancialDashboard);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/FinancialDashboard.js